__turbopack_context__.v({
  "label": "membership-level-label-module-scss-module__JU-1-G__label",
  "label__badge": "membership-level-label-module-scss-module__JU-1-G__label__badge",
});
